import API from './api';

const NewsletterService = {
    // Public: Subscribe to newsletter
    subscribe: async (email, source = null) => {
        try {
            const response = await API.post('/newsletter', { email, source });
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    // Public: Unsubscribe from newsletter
    unsubscribe: async (email) => {
        try {
            const response = await API.post('/newsletter/unsubscribe', { email });
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    // Admin: Get all subscribers
    getSubscribers: async (page = 1, limit = 20, search = '') => {
        try {
            let url = `/admin/newsletter/subscribers?page=${page}&limit=${limit}`;
            if (search) {
                url += `&search=${encodeURIComponent(search)}`;
            }
            const response = await API.get(url);
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    // Admin: Delete subscriber
    deleteSubscriber: async (id) => {
        try {
            const response = await API.delete(`/admin/newsletter/subscribers/${id}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    // Admin: Send newsletter campaign
    sendCampaign: async (subject, content) => {
        try {
            const response = await API.post('/admin/newsletter/send', { subject, content });
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    // Admin: Get campaign history
    getCampaigns: async () => {
        try {
            const response = await API.get('/admin/newsletter/campaigns');
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    // Admin: Get stats
    getStats: async () => {
        try {
            const response = await API.get('/admin/newsletter/stats');
            return response.data;
        } catch (error) {
            throw error;
        }
    },
};

export default NewsletterService;